/** `eventType` for POST /students/aina-events when user opens AINA from the widget. */
export const AINA_EVENT_WIDGET_OPEN = "aina_widget_open";
